export const getLocalUserUid = () => {
  return sessionStorage.getItem('uid')
}
